import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import '../animation/counter.js';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class DoubleInfographicAnim {
  constructor(section) {
    this.section = section;
		this.title = this.section.querySelector(".section-title");
		this.statsLeft = this.section.querySelector(".stats-left");
		this.statsRight = this.section.querySelector(".stats-right");

		this.isMobile = !window.matchMedia('(min-width: 1024px)').matches;

		this.initTitle();
		this.initBlock(this.statsLeft, 'left');
		this.initBlock(this.statsRight, 'right');
  }

	initTitle() {
		if (!this.title) return;

		document.fonts.ready.then(() => {
			this.titleSplit = SplitText.create(this.title, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.section,
					start: "top 70%",
					once: true,
				},
				onComplete: () => {
					this.titleSplit.revert();
				}
			});

			tl
				.set(this.title, {autoAlpha: 1}, 0)
				.from(this.titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 2, ease: "expo.out"}, 0);
		});
	}

	initBlock(block, direction) {
		if (!block) return;

		const bgkPicture = block.querySelector(".bgk-img");
		const infoBoxes = [...block.querySelectorAll(".stat-content")];
		const numbers = [...block.querySelectorAll(".inner-content .stat-number")];
		const descriptions = [...block.querySelectorAll(".inner-content .stat-description")];

		// Scale gutter solo su desktop
		if (!this.isMobile) {
			infoBoxes.forEach(box => {
				const gutterWidth = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--gutter'));
				const viewportWidth = window.innerWidth;
				const scaleX = viewportWidth / gutterWidth;

				gsap.set(box, {
					'--before-scale-x': scaleX,
				});
			});
		}

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: block,
				start: "top 70%",
				once: true
			},
			defaults: {force3D: true},
		});

		if (this.isMobile) {
			// Mobile: fade-in + slide-up
			tl
				.set(infoBoxes, {
					'--before-scale-x': 1,
				}, 0)
				.set(infoBoxes, {
					opacity: 1,
					yPercent: 0,
				}, 0)
				.set(numbers, {
					opacity: 1,
				}, 0)
				.counter(numbers, {
					duration: 0.8,
					increment: 1,
					stagger: 0.15,
					ease: "linear"
				}, 0.5)
				.set(descriptions, {
					opacity: 1,
				}, 0);
		} else {
			// Desktop: animazione barra scaleX originale
			tl
				.to(infoBoxes, {
					'--before-scale-x': 1,
					duration: 0.8,
					stagger: 0.3
				}, 0)
				.to(bgkPicture, {
					filter: "blur(0px)",
					duration: 0.8,
				}, 0)
				.to(numbers, {
					[direction === 'left' ? 'marginLeft' : 'marginRight']: 0,
					opacity: 1,
					duration: 0.8,
					stagger: 0.3
				}, 0.7)
				.counter(numbers, {
					duration: 0.8,
					increment: 1,
					stagger: 0.3,
					ease: "linear"
				}, 1)
				.to(descriptions, {
					opacity: 1,
					duration: 0.8,
					stagger: 0.3
				}, 0.7);
		}

			return tl;
	}
}